/* oxlint-disable */
// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  ICianApiSiteV1SearchRegionsCitiesRequest,
  TCianApiSiteV1SearchRegionsCitiesModel,
  IMappers,
  TCianApiSiteV1SearchRegionsCitiesResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { ISearchRegionsCitiesResponseSchema36 } from '../../../../entities/schemas/SearchRegionsCitiesResponseSchema36';
import type { IErrorResponseSchema37 } from '../../../../entities/schemas/ErrorResponseSchema37';

export function createCianApiSiteV1SearchRegionsCitiesModel(
  parameters: ICianApiSiteV1SearchRegionsCitiesRequest,
): TCianApiSiteV1SearchRegionsCitiesModel {
  return {
    v: 1,
    apiType: 'legacy',
    method: 'GET',
    microserviceName: 'monolith-python',
    pathApi: '/cian-api/site/v1/search-regions-cities/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface ICianApiSiteV1SearchRegionsCitiesOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: ICianApiSiteV1SearchRegionsCitiesRequest;
}

export async function fetchCianApiSiteV1SearchRegionsCities<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: ICianApiSiteV1SearchRegionsCitiesOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TCianApiSiteV1SearchRegionsCitiesResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createCianApiSiteV1SearchRegionsCitiesModel(parameters),
    config,
  )) as FetchResponse<TCianApiSiteV1SearchRegionsCitiesResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ISearchRegionsCitiesResponseSchema36, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema37, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TCianApiSiteV1SearchRegionsCitiesResponse>;
}
